var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg",attrs:{"id":"home"}},[_c('v-container',[_c('div',{staticClass:"home-content"},[_c('h1',[_c('vue-typer',{staticClass:"page-title",attrs:{"text":"Hi I'm fkubota"}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }